/* eslint-disable no-undef */
import { getApiVersion, http } from '../utils/domain'
// import { parseFormDefs } from '../utils/transformers'

const prefix = (appId) => {
  return `${getApiVersion()}/apps/${appId}`
}

export const fetchAppConfig = (appId) => {
  return http()
    .get(`${prefix(appId)}/configs`)
    .json()
}

export const fetchNavConfig = (appId) => {
  return http()
    .get(`${prefix(appId)}/navigation/current`, {
      throwHttpErrors: false,
    })
    .json()
}
// 更新导航数据
export const updateNavigation = (appId, navId, data) => {
  return http()
    .put(`${getApiVersion()}/apps/${appId}/navigation`, data, {
      throwHttpErrors: false,
    })
    .json()
}

// 新建导航
export const createNavigation = (appId, data) => {
  return http()
    .post(`${getApiVersion()}/apps/${appId}/navigation`, data, {
      throwHttpErrors: false,
    })
    .json()
}

// // SWR获取app配置信息
// export const useAppConfigSWR = (appId) => {
//   const { data, mutate, error } = useSWR(`${prefix(appId)}/configs`)
//   return {
//     ProjectConfig: data || null,
//     appConfigMutate: mutate,
//     isAppConfigLoading: !error && !data,
//     error,
//   }
// }

// // SWR获取当前角色下的导航信息
// export const useNavCurrentRoleSWR = (appId) => {
//   const { data, mutate, error } = useSWR(`${prefix(appId)}/navigation/current`)
//   return {
//     navSpec: data,
//     navsMutate: mutate,
//     isNavLoading: !error && !data,
//     error,
//   }
// }

// function getTbTagsMap(tag) {
//   if (tag === 'STANDARD') return 'standard'
//   if (tag === 'AREA') return 'area'

//   return tag
// }

// 获取app的所有表单, 可选的获取表单定义
// export const fetchTbsDef = (appId, isFetchDef = true) => {
//   return http()
//     .get(`${prefix(appId)}/tbs?def=${isFetchDef}`)
//     .json()
//     .then((res) => {
//       const tbs = {}
//       const tbIds = []

//       res.forEach((x) => {
//         tbs[x.tbId] = {
//           tbId: x.tbId,
//           appId,
//           info: x,
//           fields: parseFormDefs(x.def),
//         }
//         // FIXME: 去掉mock数据
//         if (x.tbId === 813) {
//           x.tag = 'punchIn'
//         }
//         if (x.tag !== 'GENERAL') {
//           tbs[getTbTagsMap(x.tag)] = tbs[x.tbId]
//         }
//         tbIds.push(x.tbId)
//       })
//       return {
//         tbs,
//         loadedAt: new Date().getTime(),
//         lastLoaded: 'remote',
//       }
//     })
// }

// export const useTbsSWR = (appId, store) => {
//   const { data, mutate, error } = useSWR([`apps/${appId}/tbs`], {
//     fetcher: (args) => {
//       if (args && args[1] === 'reload') {
//         return fetchTbsDef(appId).then(store.save)
//       }
//       const cacheExpired =
//         new Date().getTime() - (store.loadedAt || 0) > 6 * 60 * 1000
//       console.log('[app-tbs-cache] expired?', store.loadedAt, cacheExpired)
//       if (cacheExpired) {
//         return fetchTbsDef(appId).then(store.save)
//       }
//       return store.load().then((fdb) => {
//         if (fdb.length === 0) {
//           return fetchTbsDef(appId).then(store.save)
//         }
//         return fdb
//       })
//     },
//     dedupingInterval: 3 * 1000 * 60,
//   })

//   return {
//     ...data,
//     mutate,
//     error,
//     isTbsLoading: !error && !data,
//   }
// }
